import React, { Component } from 'react';
import Server  from './Server.js'
import {BrowserRouter , Route,Navigate,Link} from 'react-router-dom'
   
class Footer extends React.Component {
	constructor(props){
		super(props);
		this.Server = new Server();
		this.state = {
		  GridInfo:[],
		  GridBlogs:[],
            absoluteUrl:this.Server.getAbsoluteUrl(),
            url:this.Server.getUrl()
		}
	 
		
	   }
	   componentDidMount(){
		let that = this;
		let param={
			main:true
		};
		that.setState({
			loading:1
		})
		let SCallBack = function(response){
			that.setState({
				GridInfo : response.data.result
			})
			that.getBlogs();
		};
		let ECallBack = function(error){
			that.setState({
			loading:0
			})
			console.log(error)
		}
		this.Server.send("AdminApi/ShopInformation",param,SCallBack,ECallBack)
	   }
	   persianNumber(input){
		var persian = {0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹'};
		var string = (input + '').split('');
		var count = string.length;
		var num;
		for (var i = 0; i <= count; i++) {
		num = string[i];
		if (persian[num]) {
		    string[i] = persian[num];
		}
		}
		return string.join('');
	   }
	   getBlogs(){
		let that = this;
		let param={limit:5};
		that.setState({
			loading:1
		})
		let SCallBack = function(response){
			that.setState({
				GridBlogs : response.data.result
			})
		};
		let ECallBack = function(error){
			that.setState({
			loading:0
			})
			console.log(error)
		}
		this.Server.send("AdminApi/getBlogs",param,SCallBack,ECallBack)
	   }
    render(){
        return (
 			 <footer className="footer-area">
				<div >
					<div className="row">
						<div className='col-lg-12' style={{display:'flex', justifyContent:'center'}}>
							<p className="footer-top-sarv">
								<div></div>
								<span>ارتباط با ما:</span>
								<div></div>
							</p>
						</div>
						{this.state.GridInfo[0] &&

						<div className="col-md-3 col-12 order-md-1 order-3" style={{padding:5,display:'flex',justifyContent:'center',width:'100%',flexDirection:'column'}}>
								<p className="YekanBakhFaBold call-sarv" style={{textAlign:'center',fontSize:14,whiteSpace:'pre-wrap',lineHeight:2}}>
									<i className="pi pi-map-marker"></i>
									<span>{this.persianNumber(this.state.GridInfo[0].address)}</span>
								</p>
								<p className="YekanBakhFaBold call-sarv" style={{textAlign:'center',fontSize:14,whiteSpace:'pre-wrap',lineHeight:2}} >
								<i className="pi pi-phone"></i>
								<span>{this.persianNumber(this.state.GridInfo[0].call)}</span>
							</p>
							</div>
						}
						</div>
					</div>
				<div className='footer-end-sarv'>
					{this.state.GridInfo.length > 0 &&
					<div style={{textAlign:'center'}}>
						<p style={{margin:0,color:"#fff"}} className="yekan">استفاده از مطالب وبسایت اینترنتی {this.state.GridInfo[0].name} فقط برای مقاصد غیرتجاری و با ذکر منبع بلامانع است. کلیه حقوق این سایت متعلق به {this.state.GridInfo[0].name} می‌باشد.</p>
					</div>
					
					}
					<div style={{textAlign:'center',paddingBottom:10}}>
							<p style={{margin:0,color:"#fff"}} className="yekan">طراحی و پیاده سازی توسط <a href="http://ansar724.com" target="_blank" style={{color:'#a9a9a9'}}>داده پرداز سرو آرا</a></p>
					</div>
				</div>
			</footer>


        )
    }
}
export default Footer;